import script from "./FilterCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./FilterCheckbox.vue?vue&type=style&index=0&id=64da2796&lang=scss"

const __exports__ = script;

export default __exports__